import type { Translations } from './error-messages.types'

/** French texts of backend messages (ADR-045). Missing keys show the English text. */
export const fr: Translations = {
  'appointments.appointment_completed_after_has_started':
    'Un rendez-vous ne peut être terminé qu’après avoir commencé.',
  'appointments.appointment_does_need_payment':
    'Ce rendez-vous ne nécessite pas de paiement.',
  'appointments.appointment_no_longer_changed':
    'Ce rendez-vous ne peut plus être modifié.',
  'appointments.appointment_that':
    'Cette action est impossible pour un rendez-vous au statut « {value2} ».',
  'appointments.booking_request_invalid':
    'La demande de réservation est invalide.',
  'appointments.captured_payments_refunded':
    'Seuls les paiements encaissés peuvent être remboursés.',
  'appointments.changes_possible_until_hours_before':
    'Les modifications sont possibles jusqu’à {cutoff} heures avant le rendez-vous.',
  'appointments.exception_invalid': 'L’exception est invalide.',
  'appointments.invalid_amount': 'Montant invalide.',
  'appointments.invalid_date_range': 'Période invalide.',
  'appointments.invalid_start_time': 'Heure de début invalide.',
  'appointments.invalid_translations': 'Traductions invalides.',
  'appointments.invalid_webhook_signature': 'Signature de webhook invalide.',
  'appointments.key_already_used': 'La clé est déjà utilisée.',
  'appointments.location_invalid': 'Le lieu est invalide.',
  'appointments.no_show_recorded_after_start':
    'Une absence ne peut être enregistrée qu’après l’heure de début.',
  'appointments.online_cancel_unavailable':
    'L’annulation en ligne n’est pas disponible pour ce rendez-vous.',
  'appointments.online_reschedule_unavailable':
    'Le déplacement en ligne n’est pas disponible pour ce rendez-vous.',
  'appointments.paid_service_needs_price':
    'Une prestation payante nécessite un prix.',
  'appointments.payment_deadline_has_passed':
    'Le délai de paiement est dépassé.',
  'appointments.payment_method_available':
    'Ce moyen de paiement n’est pas disponible.',
  'appointments.pending_appointments_confirmed_status':
    'Seuls les rendez-vous en attente peuvent être confirmés (statut {aStatus}).',
  'appointments.please_choose_staff_member':
    'Veuillez choisir un membre de l’équipe.',
  'appointments.policy_page_does_exist': 'La page de conditions n’existe pas.',
  'appointments.refund_exceeds_refundable_amount':
    'Le remboursement dépasse le montant remboursable.',
  'appointments.refund_failed': 'Le remboursement a échoué : {message}',
  'appointments.refunds_supported':
    '{adapterLabel} ne prend pas en charge les remboursements.',
  'appointments.schedule_invalid': 'Le planning est invalide.',
  'appointments.selected_time_no_longer_available':
    'L’horaire choisi n’est plus disponible.',
  'appointments.service_invalid': 'La prestation est invalide.',
  'appointments.staff_member_does_work_at':
    'Ce membre de l’équipe ne travaille pas dans ce lieu.',
  'appointments.staff_member_invalid': 'Le membre de l’équipe est invalide.',
  'appointments.supports_full_refunds':
    '{adapterLabel} ne prend en charge que les remboursements complets.',
  'appointments.test_provider_disabled_production':
    'Le prestataire de test est désactivé en production.',
  'appointments.too_many_requests_please_wait':
    'Trop de requêtes ({name}). Veuillez patienter un instant.',
  'appointments.unexpected_plugin': 'Extension inattendue.',
  'appointments.unknown': 'Inconnu : {kind}.',
  'appointments.unknown_location': 'Lieu inconnu.',
  'appointments.unknown_staff_member': 'Membre de l’équipe inconnu.',
  'auth.access_token_expired': 'Le jeton d’accès a expiré.',
  'auth.account_active': 'Le compte n’est pas actif.',
  'auth.api_provided_plugin_which_enabled':
    'Cette API est fournie par l’extension « {pluginKey} », qui n’est pas activée.',
  'auth.feature_turned_off': 'La fonctionnalité « {feature} » est désactivée.',
  'auth.invalid_access_token': 'Jeton d’accès invalide.',
  'auth.invalid_token_type': 'Type de jeton invalide.',
  'auth.plugin_active': 'L’extension n’est pas active.',
  'auth.plugin_credentials_accepted_service':
    'Ce service n’accepte pas les identifiants d’extension.',
  'auth.plugin_enabled': 'L’extension « {callerPluginKey} » n’est pas activée.',
  'auth.plugin_has_been_granted':
    'L’extension « {callerPluginKey} » n’a pas reçu « {capability} ».',
  'auth.unknown_token_signing_key': 'Clé de signature de jeton inconnue.',
  'backup.coordinator_only':
    'Seul le coordinateur de sauvegarde peut utiliser ce point de terminaison.',
  'backup.import_failed': 'Les données n’ont pas pu être chargées : {reason}',
  'backup.import_running': 'Une importation est en cours.',
  'backup.link_expired': 'Le lien de téléchargement est invalide ou a expiré.',
  'backup.not_importable':
    'Cette sauvegarde ne peut pas être importée ici. Envoyez-la de nouveau pour en voir la raison.',
  'common.dependency_unavailable':
    'Un service requis ({dependency}) est indisponible.',
  'common.forbidden':
    'Vous n’avez pas l’autorisation d’effectuer cette action.',
  'common.not_found': 'Introuvable ({resource}).',
  'common.not_found_id': 'Introuvable ({resource} « {id} »).',
  'common.request_invalid': 'La requête est invalide.',
  'common.unauthenticated': 'Une connexion est requise.',
  'common.unexpected': 'Une erreur inattendue est survenue.',
  'contact.invalid_message': 'Please check the form.',
  'contact.invalid_settings': 'Invalid settings.',
  'contact.recaptcha_failed':
    'La vérification anti-spam a échoué. Veuillez réessayer.',
  'contact.recaptcha_keys_missing':
    'Saisissez les deux clés reCAPTCHA pour l’activer.',
  'contact.recaptcha_unavailable':
    'La vérification anti-spam n’est pas disponible pour le moment. Veuillez réessayer plus tard.',
  'contact.too_many_messages':
    'Too many messages. Please try again in a few minutes.',
  'content.active_content_type_needs_at':
    'Un type de contenu actif doit avoir au moins un champ.',
  'site.invalid_settings': 'Vérifiez les paramètres du site web.',
  'content.add_at_least_one_field':
    'Ajoutez au moins un champ avant l’activation.',
  'content.at_most_5_filters_allowed': '5 filtres au maximum sont autorisés.',
  'content.changing_field_compatible_existing_entries':
    'Transformer un champ {type} en {type2} est incompatible avec les entrées existantes.',
  'content.content_type_already_exists':
    'Le type de contenu « {inputKey} » existe déjà.',
  'content.entries_archived_content_types_published':
    'Les entrées des types de contenu archivés ne peuvent pas être publiées.',
  'content.entries_created_active_content_types':
    'Les entrées ne peuvent être créées que pour des types de contenu actifs.',
  'content.entry_data_invalid': 'Les données de l’entrée sont invalides.',
  'content.entry_has_no_draft_preview':
    'L’entrée n’a pas de brouillon à prévisualiser.',
  'content.entry_has_no_draft_version':
    'L’entrée n’a pas de version brouillon.',
  'content.entry_languages_invalid': 'Les langues de l’entrée sont invalides.',
  'content.entry_published': 'L’entrée n’est pas publiée.',
  'content.entry_ready_publish': 'L’entrée n’est pas prête à être publiée.',
  'content.entry_referenced':
    '{count} autres entrées renvoient à cette entrée. Supprimez quand même pour retirer ces liens.',
  'content.entry_referenced_one':
    'Une autre entrée renvoie à cette entrée. Supprimez quand même pour retirer le lien.',
  'content.entry_status':
    'Cette action est impossible pour une entrée au statut {status}.',
  'content.entry_was_changed_someone_else':
    'Cette entrée a été modifiée par quelqu’un d’autre. Rechargez pour voir la dernière version.',
  'content.field_keys_renamed_while_entries':
    'Les clés de champ ne peuvent pas être renommées tant que des entrées existent ; ajoutez plutôt un nouveau champ.',
  'content.fieldids_must_list_every_field':
    'fieldIds doit lister chaque champ du type de contenu exactement une fois.',
  'content.filter_must_map_field_keys':
    'filter doit associer des clés de champ à des valeurs texte.',
  'content.filter_must_number': 'filter[{fieldKey}] doit être un nombre.',
  'content.filtering_supported':
    'Le filtrage par « {fieldKey} » n’est pas pris en charge.',
  'content.invalid_content_type_key': 'Clé de type de contenu invalide.',
  'content.invalid_content_type_settings':
    'Paramètres de type de contenu invalides.',
  'content.invalid_field_definition': 'Définition de champ invalide.',
  'content.invalid_schedule_time': 'Horaire invalide.',
  'content.invalid_slug': 'Slug invalide.',
  'content.localized_setting_change_while_entries':
    'Le paramètre « traduit » ne peut pas changer tant que des entrées existent.',
  'content.multiple_setting_change_while_entries':
    'Le paramètre « valeurs multiples » ne peut pas changer tant que des entrées existent.',
  'content.page_available':
    'La page « {path} » n’est pas disponible en « {locale} ».',
  'content.preview_link_invalid_has_expired':
    'Le lien d’aperçu est invalide ou a expiré.',
  'content.publishing_restored_version_requires_content':
    'Publier une version restaurée nécessite content.entry.publish.',
  'content.reserved_key': '« {key} » est une clé réservée.',
  'content.scheduled_time_must_future':
    'L’horaire planifié doit être dans le futur.',
  'content.slug_already_used_another_entry':
    'Le slug « {slug} » est déjà utilisé par une autre entrée ({typeName}).',
  'content.type_has_entries':
    'Ce type de contenu a {count} entrées. Supprimez avec « force » pour les supprimer aussi, ou archivez le type.',
  'content.type_has_entry':
    'Ce type de contenu a une entrée. Supprimez avec « force » pour la supprimer aussi, ou archivez le type.',
  'content.unsupported_locale': 'Langue non prise en charge : « {locale} ».',
  'content.url_already_used_another_published':
    'L’URL {nextPath} est déjà utilisée par une autre entrée publiée.',
  'content.url_prefix_already_reserved':
    'Le préfixe d’URL « {prefix} » est déjà réservé par {owner}.',
  'content.url_prefix_already_used_content':
    'Le préfixe d’URL « {prefix} » est déjà utilisé par le type de contenu « {otherKey} ».',
  'content.url_prefix_already_used_content_2':
    'Le préfixe d’URL « {prefix} » est déjà utilisé par le type de contenu « {key} ».',
  'content.url_prefix_reserved': 'Le préfixe d’URL « {prefix} » est réservé.',
  'content.url_prefix_reserved_2':
    'Le préfixe d’URL « {prefix} » est réservé par {value}.',
  'content.you_delete_entries_you_created':
    'Vous ne pouvez supprimer que les entrées que vous avez créées.',
  'crm.account_already_linked': 'Ce compte est déjà lié.',
  'crm.account_linked': 'Ce compte n’est pas lié.',
  'crm.adjustments_need_reason': 'Les ajustements nécessitent un motif.',
  'crm.another_price_already_valid_period':
    'Un autre prix est déjà valable sur cette période. Modifiez-le ou supprimez-le d’abord.',
  'crm.available_sale': '{fName} ({sku}) n’est pas disponible à la vente.',
  'crm.calendar_range_invalid':
    'Choisissez une période de {max} jours au maximum.',
  'crm.category_already_exists': 'La catégorie « {inputKey} » existe déjà.',
  'crm.category_own_ancestor':
    'Une catégorie ne peut pas être son propre ancêtre.',
  'crm.choose_active_person': 'Choisissez une personne active.',
  'crm.choose_customer_create_new_one':
    'Choisissez un client ou créez-en un nouveau.',
  'crm.choose_two_different_customers': 'Choisissez deux clients différents.',
  'crm.choose_two_different_warehouses':
    'Choisissez deux entrepôts différents.',
  'crm.comment_invalid': 'The comment is invalid.',
  'crm.count_has_no_lines': 'L’inventaire n’a aucune ligne.',
  'crm.count_no_longer_editable': 'Cet inventaire n’est plus modifiable.',
  'crm.count_was_already_posted_cancelled':
    'Cet inventaire a déjà été comptabilisé ou annulé.',
  'crm.customer_anonymized_no_tickets': 'Ce client a été anonymisé.',
  'crm.customer_has_been_anonymized': 'Ce client a été anonymisé.',
  'crm.customer_was_merged_into_another':
    'Ce client a été fusionné avec un autre client.',
  'crm.delete_detach_variants_first':
    'Supprimez ou détachez d’abord les variantes.',
  'crm.document_invalid': 'The document is invalid.',
  'crm.document_multipart':
    'Upload the document as multipart/form-data with a "file" part.',
  'crm.enough_available': 'Pas assez de {context} : {value} disponible(s).',
  'crm.enough_stock': 'Stock insuffisant.',
  'crm.event_invalid': 'L’événement n’est pas valide.',
  'crm.idempotency_key_too_long': 'Clé d’idempotence trop longue.',
  'crm.import_columns_missing':
    'The file needs a first_name, last_name or company_name column.',
  'crm.import_file_invalid': 'The import file cannot be read.',
  'crm.import_file_missing': 'A "file" part is required.',
  'crm.import_malformed': 'Malformed upload: {message}',
  'crm.import_multipart':
    'Upload the file as multipart/form-data with a "file" part.',
  'crm.import_too_large': 'The import file may be at most {max} bytes.',
  'crm.invalid_amount': 'Montant invalide.',
  'crm.invalid_category_key': 'Clé de catégorie invalide.',
  'crm.invalid_contact': 'Contact invalide.',
  'crm.invalid_contacts': 'Contacts invalides.',
  'crm.invalid_country': 'Pays invalide.',
  'crm.invalid_e_mail': 'E-mail invalide.',
  'crm.invalid_expiry': 'Expiration invalide.',
  'crm.invalid_quantity': 'Quantité invalide.',
  'crm.invalid_reorder_level': 'Seuil de réapprovisionnement invalide.',
  'crm.invalid_reservation_lines': 'Lignes de réservation invalides.',
  'crm.invalid_sku': 'Référence invalide.',
  'crm.invalid_validity_interval': 'Période de validité invalide.',
  'crm.invalid_warehouse_code': 'Code d’entrepôt invalide.',
  'crm.name_required': 'Un nom est requis.',
  'crm.no_active_warehouse': 'Create an active warehouse first.',
  'crm.note_empty': 'Une note ne peut pas être vide.',
  'crm.nothing_post': 'Rien à comptabiliser.',
  'crm.offering_invalid': 'Cette combinaison n’est pas possible.',
  'crm.only_own_comments': 'You can only delete your own comments.',
  'crm.price_list_already_exists':
    'La liste de prix « {inputKey} » existe déjà.',
  'crm.product_has_stock_history_deleted':
    'Ce produit a un historique de stock et ne peut pas être supprimé. Archivez-le plutôt.',
  'crm.product_own_variant': 'Un produit ne peut pas être sa propre variante.',
  'crm.reminder_invalid': 'The reminder is invalid.',
  'crm.reminder_not_scheduled': 'The reminder was already sent or cancelled.',
  'crm.reservation_not_changeable':
    'La réservation est {status} et ne peut plus être modifiée.',
  'crm.external_reference_ambiguous':
    'Plusieurs clients ont cette référence externe.',
  'crm.service_code_taken': 'Un service avec ce code existe déjà.',
  'crm.service_integration_client_crm':
    'Le service « {serviceName} » n’est pas un client d’intégration du CRM.',
  'crm.service_invalid': 'Le service n’est pas valide.',
  'crm.sku_already_use': 'La référence « {sku} » est déjà utilisée.',
  'crm.stock_balance_was_locked': 'Le solde de stock n’était pas verrouillé.',
  'crm.stock_quantity_invalid': 'The stock quantity is invalid.',
  'crm.stock_tracked_product': 'Le stock n’est pas suivi pour ce produit.',
  'crm.that_customer_already_linked_another':
    'Ce client est déjà lié à un autre compte.',
  'crm.ticket_closed': 'Ce ticket est fermé. Veuillez en ouvrir un nouveau.',
  'crm.ticket_invalid': 'Le ticket n’est pas valide.',
  'crm.ticket_message_invalid': 'Le message n’est pas valide.',
  'crm.ticket_not_shared':
    'Partagez le ticket avec le client avant de répondre, ou ajoutez une note interne.',
  'crm.ticket_too_many_open':
    'Vous avez {max} tickets ouverts. Veuillez attendre une réponse avant d’en ouvrir un autre.',
  'crm.ticket_verify_email':
    'Veuillez confirmer votre adresse e-mail avant d’ouvrir un ticket.',
  'crm.unknown_product': 'Produit inconnu.',
  'crm.unknown_warehouse': 'Entrepôt inconnu.',
  'crm.unsupported_currency': 'Devise non prise en charge.',
  'crm.use_reservation_transfer_commands_movement':
    'Utilisez les commandes de réservation ou de transfert pour ce mouvement.',
  'crm.variants_have_variants':
    'Les variantes ne peuvent pas avoir de variantes.',
  'crm.warehouse_already_exists': 'L’entrepôt « {code} » existe déjà.',
  'crm.warehouse_has_stock_history_deactivate':
    'Cet entrepôt a un historique de stock. Désactivez-le plutôt.',
  'crm.warehouse_inactive': 'L’entrepôt {wCode} est inactif.',
  'crm.you_delete_your_own_notes':
    'Vous ne pouvez supprimer que vos propres notes.',
  'crm.zip_selection_invalid': 'Select 1 to {max} documents.',
  'crm.zip_too_large': 'The selected documents are too large for one download.',
  'http.400': 'La requête est invalide.',
  'http.401': 'Une connexion est requise.',
  'http.403': 'Vous n’avez pas l’autorisation d’effectuer cette action.',
  'http.404': 'Introuvable.',
  'http.405': 'Cette méthode n’est pas autorisée.',
  'http.409': 'La requête est en conflit avec l’état actuel.',
  'http.413': 'La requête est trop volumineuse.',
  'http.415': 'Ce type de média n’est pas pris en charge.',
  'http.429': 'Trop de requêtes. Veuillez réessayer plus tard.',
  'identity.administrator_permissions_changed':
    'Les autorisations du rôle administrateur ne peuvent pas être modifiées.',
  'identity.at_least_one_active_administrator':
    'Au moins un administrateur actif doit rester.',
  'identity.csrf_token_missing_invalid': 'Jeton CSRF manquant ou invalide.',
  'identity.current_password_incorrect':
    'Le mot de passe actuel est incorrect.',
  'identity.displayname_must_1_120_characters':
    'Le nom d’affichage doit comporter de 1 à 120 caractères.',
  'identity.invalid_client_credentials': 'Identifiants client invalides.',
  'identity.invalid_credentials': 'E-mail ou mot de passe incorrect.',
  'identity.invalid_email_address': 'Adresse e-mail invalide.',
  'identity.invalid_plugin_key': 'Clé d’extension invalide.',
  'identity.invalid_plugin_permissions': 'Autorisations d’extension invalides.',
  'identity.invalid_role_key': 'Clé de rôle invalide.',
  'identity.address_belongs_staff_user':
    'Cette adresse e-mail appartient à un utilisateur de l’équipe.',
  'identity.link_invalid_expired': 'Ce lien est invalide ou a expiré.',
  'identity.no_active_session': 'Aucune session active.',
  'identity.notification_invalid': 'The notification is invalid.',
  'identity.one_more_roles_do_exist': 'Un ou plusieurs rôles n’existent pas.',
  'identity.password_does_meet_password_policy':
    'Le mot de passe ne respecte pas la politique de mots de passe.',
  'identity.please_confirm_your_e_mail':
    'Veuillez d’abord confirmer votre adresse e-mail. Nous vous avons envoyé un lien.',
  'identity.role_already_exists': 'Le rôle « {inputKey} » existe déjà.',
  'identity.service_may_request_plugin_credentials':
    'Ce service ne peut pas demander d’identifiants d’extension.',
  'identity.session_expired_please_sign_again':
    'La session a expiré. Veuillez vous reconnecter.',
  'identity.status_set_manually':
    'Le statut ne peut pas être défini manuellement sur {to}.',
  'identity.system_roles_deleted':
    'Les rôles système ne peuvent pas être supprimés.',
  'identity.unknown_permissions': 'Autorisations inconnues.',
  'identity.unknown_token_signing_key': 'Clé de signature de jeton inconnue.',
  'identity.user_email_already_exists':
    'Un utilisateur avec cette adresse e-mail existe déjà.',
  'identity.you_delete_your_own_account':
    'Vous ne pouvez pas supprimer votre propre compte.',
  'identity.you_disable_your_own_account':
    'Vous ne pouvez pas désactiver votre propre compte.',
  'issue.add_at_least_one_line': 'ajoutez au moins une ligne',
  'issue.add_at_least_one_product': 'ajoutez au moins un produit',
  'issue.already_used': 'est déjà utilisé',
  'issue.ambiguous_match': 'several customers have this e-mail address',
  'issue.assign_staff_member_location_first':
    'rattachez d’abord la personne à ce lieu',
  'issue.at_least_one_interval': 'au moins une plage horaire',
  'issue.at_most_200_characters': '200 caractères au maximum',
  'issue.at_most_refunded': '{remaining} au maximum peut être remboursé',
  'issue.available': 'seulement {total} disponible(s)',
  'issue.available_2': 'seulement {available} disponible(s)',
  'issue.available_3':
    '« {shippingMethod} » n’est pas disponible pour {destination}',
  'issue.available_4': '« {provider} » n’est pas disponible',
  'issue.available_5': 'seulement {available} sur {value} disponible(s)',
  'issue.belongs_gx_cms_core': '« {prefix} » appartient au cœur de GX-CMS',
  'issue.belongs_plugin': '« {dKey} » appartient à l’extension « {owner} »',
  'issue.choose_at_least_one_feature': 'choose at least one feature',
  'issue.choose_at_least_one_language': 'choisissez au moins une langue',
  'issue.choose_one_offered_payment_methods':
    'choisissez l’un des moyens de paiement proposés',
  'issue.cms_page_published': 'la page CMS {path} n’est pas publiée',
  'issue.configured_e_mails_logged':
    'non configuré : les e-mails sont seulement journalisés',
  'issue.contains_unknown_ids': 'contient des identifiants inconnus',
  'issue.contains_unknown_role_ids':
    'contient des identifiants de rôle inconnus',
  'issue.content_language': 'n’est pas une langue de contenu',
  'issue.content_language_use':
    '« {l} » n’est pas une langue de contenu (possibles : {supported})',
  'issue.core_permission': '« {dKey} » est une autorisation du cœur',
  'issue.count_at_least_one_product': 'comptez au moins un produit',
  'issue.crm_has_no_price_list':
    'Le CRM n’a pas de liste de prix « {priceList} ». Créez-la dans CRM → Produits → Listes de prix ou modifiez la configuration de la boutique.',
  'issue.crm_plugin_disabled_unreachable_storefront':
    'L’extension CRM est désactivée ou injoignable. La boutique affiche les produits sans prix ni stock, et la commande est suspendue jusqu’au retour du CRM.',
  'issue.crm_price_lists_could_read':
    'Les listes de prix du CRM n’ont pas pu être lues.',
  'issue.does_exist': 'n’existe pas',
  'issue.does_track_stock': 'le stock de {sku} n’est pas suivi',
  'issue.duplicate_field_key': 'clé de champ en double « {fKey} »',
  'issue.duplicate_in_file': 'also in row {line}',
  'issue.e_mail_address': 'n’est pas une adresse e-mail',
  'issue.eligible_customer': 'client non éligible',
  'issue.email_not_verified': 'adresse e-mail pas encore confirmée',
  'issue.end_after_start': 'doit être après le début',
  'issue.entries_type_allowed_here':
    'les entrées de type « {contentTypeKey} » ne sont pas autorisées ici',
  'issue.entry_reference_itself': 'une entrée ne peut pas renvoyer à elle-même',
  'issue.enum_fields_need_at_least':
    'les champs de choix nécessitent au moins une option',
  'issue.error': '{fName} ({sku}) : {message}',
  'issue.event_too_long': 'un événement peut durer au maximum {max} jours',
  'issue.exactly_one_customerid_createcustomer':
    'exactement un parmi customerId / createCustomer',
  'issue.exceed_price': 'ne peut pas dépasser le prix',
  'issue.field_content_type': 'n’est pas un champ de ce type de contenu',
  'issue.fields_hold_multiple_values':
    'les champs {type} ne peuvent pas contenir plusieurs valeurs',
  'issue.file_does_exist_inside_package':
    'le fichier « {rel} » est absent du paquet (l’extension a-t-elle été compilée ?)',
  'issue.file_empty': 'The file is empty.',
  'issue.file_too_large': 'The file is too large.',
  'issue.file_unreadable': 'The file is not a valid Excel workbook.',
  'issue.filterable': 'non filtrable',
  'issue.from_must_yyyy_mm_dd': 'from et to doivent être au format AAAA-MM-JJ',
  'issue.has_no_matching_events_subscribe':
    '« {cap} » n’a pas de déclaration events.subscribe correspondante',
  'issue.import_name_column': 'no name column',
  'issue.import_sku_name_columns': 'sku and name are required',
  'issue.incorrect': 'est incorrect',
  'issue.intervals_overlap': 'les plages se chevauchent',
  'issue.http_url': 'doit être une URL http(s)',
  'issue.website_language': 'doit être l’une des langues du site web',
  'issue.invalid': 'est invalide',
  'issue.invalid_attendees': 'indiquez au maximum {max} membres de l’équipe',
  'issue.inventory_needs_products': 'le suivi du stock nécessite des produits',
  'issue.iso_date': 'must be a date',
  'issue.job_ids_must_unique': 'les identifiants de tâche doivent être uniques',
  'issue.length_between': '1 to {min} characters',
  'issue.location_staff_required': 'un lieu ou une personne est requis',
  'issue.max_characters': 'must be at most {max} characters',
  'issue.max_items': 'at most {max} tags',
  'issue.max_recipients': 'must have at most {max} recipients',
  'issue.media_asset_does_exist': 'le média {assetId} n’existe pas',
  'issue.media_asset_ready':
    'le média {assetId} n’est pas prêt ({assetStatus})',
  'issue.media_type_allowed': 'le type de média {mimeType} n’est pas autorisé',
  'issue.migration_ids_must_unique':
    'les identifiants de migration doivent être uniques',
  'issue.minitems_maxitems_require_multiple_true':
    'minItems/maxItems nécessitent multiple=true',
  'issue.must_1_7': 'doit être entre 1 et 7',
  'issue.must_above_zero': 'doit être supérieur à zéro',
  'issue.must_accepted': 'doit être accepté',
  'issue.must_after_from_at_most':
    'doit être égal ou postérieur au début, 31 jours au maximum',
  'issue.must_after_validfrom': 'doit être postérieur à validFrom',
  'issue.must_at_least_characters':
    'doit comporter au moins {minLength} caractères',
  'issue.must_at_most_256_characters': 'doit comporter au plus 256 caractères',
  'issue.must_between': 'must be between {min} and {max}',
  'issue.must_boolean': 'doit être un booléen',
  'issue.must_cms_path_like_terms': 'doit être un chemin CMS comme /terms',
  'issue.must_contain_at_least_three':
    'doit contenir au moins trois parmi : minuscule, majuscule, chiffre, symbole',
  'issue.must_contain_duplicates': 'ne doit pas contenir de doublons',
  'issue.must_differ_from_source': 'doit être différent de la source',
  'issue.must_differ_from_target': 'doit être différent de la cible',
  'issue.must_endpoint_signing_secret_whsec':
    'doit être le secret de signature du point de terminaison (whsec_…)',
  'issue.must_fixed_percent': 'doit être FIXED ou PERCENT',
  'issue.must_future': 'doit être dans le futur',
  'issue.must_future_within_minutes':
    'doit être dans le futur et dans les {RESERVATIONMAXMINUTES} minutes',
  'issue.must_have_form_pluginkey_widgetid':
    'doit avoir la forme <pluginKey>/<widgetId>',
  'issue.must_host_name': 'must be a host name',
  'issue.must_http_s_url_template': 'doit être un modèle d’URL http(s)',
  'issue.must_https_url': 'doit être une URL https://',
  'issue.must_iana_time_zone_such':
    'doit être un fuseau horaire IANA comme Europe/Budapest',
  'issue.must_integer': 'doit être un entier de {min} à {max}',
  'issue.must_iso_3166_1_alpha': 'doit être au format ISO 3166-1 alpha-2',
  'issue.must_iso_8601_instant': 'doit être un instant ISO 8601',
  'issue.must_iso_date_time': 'doit être une date et heure ISO',
  'issue.must_list_non_empty_strings':
    'doit être une liste de textes non vides',
  'issue.must_max': 'doit être <= max',
  'issue.must_maxitems': 'doit être <= maxItems',
  'issue.must_maxlength': 'doit être <= maxLength',
  'issue.must_newer_than_plugin_version':
    'ne doit pas être plus récent que la version de l’extension',
  'issue.must_non_negative_integer': 'doit être un entier positif ou nul',
  'issue.must_non_negative_integer_minor':
    'doit être un entier positif ou nul en centimes',
  'issue.must_non_zero_integer': 'doit être un entier non nul',
  'issue.must_none_tls': 'must be none or tls',
  'issue.must_number': 'doit être un nombre',
  'issue.must_object': 'doit être un objet',
  'issue.must_one': 'doit être l’un de {FIELDTYPES}',
  'issue.must_positive_integer': 'doit être un entier positif',
  'issue.must_positive_integer_minor_units':
    'doit être un entier positif (en centimes)',
  'issue.must_reference_another_product': 'doit renvoyer à un autre produit',
  'issue.must_reference_base_product': 'doit renvoyer à un produit de base',
  'issue.must_reference_single_value_text':
    'doit renvoyer à un champ texte à valeur unique',
  'issue.must_single_non_localized_enum':
    'doit être un champ de choix ou de relation unique et non traduit',
  'issue.must_start': 'doit commencer par « {ns} »',
  'issue.must_start_letter_contain_letters':
    'doit commencer par une lettre et ne contenir que des lettres, chiffres et _',
  'issue.must_stripe_secret_restricted_key':
    'doit être une clé secrète ou restreinte Stripe (sk_…/rk_…)',
  'issue.must_text_at_most_120':
    'doit être un texte de 120 caractères au maximum',
  'issue.must_url_path': 'doit être { url } ou { path }',
  'issue.must_valid_email_address': 'doit être une adresse e-mail valide',
  'issue.must_valid_regular_expression':
    'doit être une expression régulière valide',
  'issue.must_valid_semver_range': 'doit être une plage semver valide',
  'issue.must_yyyy_mm_dd': 'doit être au format AAAA-MM-JJ',
  'issue.needs_hh_mm_start_before': 'format HH:mm requis, début avant fin',
  'issue.no_active_shipping_method': 'Aucun mode de livraison actif.',
  'issue.no_longer_available': '{value} n’est plus disponible',
  'issue.no_payment_method_enabled_configured':
    'Aucun moyen de paiement n’est activé et configuré.',
  'issue.no_published_cms_page_at': 'aucune page CMS publiée à {path}',
  'issue.non_negative_amount': 'doit être un montant positif ou nul',
  'issue.not_in_past': 'must not be in the past',
  'issue.notification_link': 'must be an admin path starting with /',
  'issue.notification_permissions': 'must be permission keys',
  'issue.notification_recipients': 'name at least one user or permission',
  'issue.notification_source': 'use lower-case letters, digits and . _ : -',
  'issue.notification_text': 'use a text or { "<language>": text }',
  'issue.notification_too_many_users': 'at most {max} users',
  'issue.notification_type': 'use lower-case letters, digits and . _ -',
  'issue.notification_user_ids': 'must be user ids',
  'issue.page_widget_field_widget_ids':
    'les identifiants de page, de widget et de widget de champ doivent être uniques',
  'issue.paid_service_needs_currency':
    'une prestation payante nécessite une devise',
  'issue.paid_service_needs_price_above':
    'une prestation payante nécessite un prix supérieur à zéro',
  'issue.permission_keys_must_unique':
    'les clés d’autorisation doivent être uniques',
  'issue.plugin_depend_itself':
    'une extension ne peut pas dépendre d’elle-même',
  'issue.positive_minutes': 'doit être un nombre de minutes positif',
  'issue.posted_directly':
    '« {type} » ne peut pas être comptabilisé directement',
  'issue.product_does_exist': 'le produit {id} n’existe pas',
  'issue.provide_display_name_person_name':
    'indiquez un nom d’affichage, un nom de personne ou un nom d’entreprise',
  'issue.range_too_long': 'est hors de la plage autorisée',
  'issue.referenced_entry_archived':
    'l’entrée liée {targetEntryId} est archivée',
  'issue.referenced_entry_does_exist':
    'l’entrée liée {targetEntryId} n’existe pas',
  'issue.references_undeclared_feature':
    "references undeclared feature '{feature}'",
  'issue.references_undeclared_page':
    'renvoie à la page non déclarée « {page} »',
  'issue.reminder_range': 'doit être compris entre 0 minute et 14 jours',
  'issue.requested_plugin': '« {c} » n’est pas demandé par l’extension',
  'issue.required': 'est obligatoire',
  'issue.required_8_120_characters': 'est obligatoire (8 à 120 caractères)',
  'issue.required_content_type': 'est obligatoire pour ce type de contenu',
  'issue.required_event_subscriptions_jobs':
    'est obligatoire pour les abonnements aux événements et les tâches',
  'issue.required_price_iso_4217': 'est obligatoire avec un prix (ISO 4217)',
  'issue.required_service': 'est obligatoire pour cette prestation',
  'issue.required_verify_webhooks':
    'est obligatoire pour vérifier les webhooks',
  'issue.required_when_admin_ui_extensions':
    'est obligatoire lorsque des extensions d’administration sont déclarées',
  'issue.required_when_permissions_features_declared':
    'est obligatoire lorsque des autorisations ou fonctionnalités sont déclarées',
  'issue.requires_capability': '{why} nécessite la capacité « {cap} »',
  'issue.reserved': 'est réservé',
  'issue.reserved_2': '« {fieldKey} » est réservé',
  'issue.reserved_3': '« {prefix} » est réservé',
  'issue.reserved_storefront': '« {categorySlug} » est réservé par la boutique',
  'issue.row_failed': 'could not be imported',
  'issue.select_documents': 'select 1 to {max} documents',
  'issue.sender_name': 'must be at most 120 characters without < > or quotes',
  'issue.shop_currency_but_crm_price':
    'La devise de la boutique est {currency}, mais la liste de prix CRM « {priceList} » est en {currency2}. Créez une liste de prix en {currency} et sélectionnez-la dans la configuration de la boutique, ou passez la devise de la boutique en {currency3}.',
  'issue.simplepay_supports_huf_eur_usd':
    'SimplePay prend en charge HUF, EUR et USD',
  'issue.supported': '« {currency} » n’est pas pris en charge',
  'issue.supported_fields': 'n’est pas pris en charge pour les champs {type}',
  'issue.supported_locale': 'n’est pas une langue prise en charge',
  'issue.supported_routing_setting':
    'n’est pas un paramètre de routage pris en charge',
  'issue.supported_setting': 'n’est pas un paramètre pris en charge',
  'issue.tag_max_characters': 'tags must be at most {max} characters',
  'issue.tax_rate_range': 'doit être compris entre 0 et 100 %',
  'issue.teaor_format': 'chiffres et points, p. ex. 62.01',
  'issue.test_provider_used_production':
    'le prestataire de test ne peut pas être utilisé en production',
  'issue.too_large': 'est trop grand',
  'issue.too_long': 'est trop long',
  'issue.too_long_max_1000': 'est trop long (max. 1000)',
  'issue.too_many_columns': 'The file has too many columns (at most {max}).',
  'issue.too_many_rows': 'The file has too many rows (at most {max}).',
  'issue.translations_fields': 'format attendu : { "<langue>": { {fields} } }',
  'issue.unavailable': 'indisponible',
  'issue.unknown_capability': 'capacité inconnue « {cap} »',
  'issue.unknown_field': 'champ inconnu',
  'issue.unknown_permission': 'autorisation inconnue « {p} »',
  'issue.unsupported_currency': 'n’est pas pris en charge',
  'issue.use_0': 'utilisez une valeur de 0 à {MAXQTY}',
  'issue.use_1_32_letters_digits':
    'utilisez 1 à 32 lettres, chiffres, tirets ou traits de soulignement',
  'issue.use_1_64_letters_digits':
    'utilisez 1 à 64 lettres, chiffres, points, tirets ou traits de soulignement',
  'issue.use_2_63_lowercase_letters':
    'utilisez 2 à 63 minuscules, chiffres ou _, en commençant par une lettre',
  'issue.use_either_https_url_cms':
    'utilisez soit une URL HTTPS, soit un chemin CMS, pas les deux',
  'issue.use_iso_3166_1_alpha': 'utilisez un code ISO 3166-1 alpha-2',
  'issue.use_lower_case_letters_digits':
    'utilisez des minuscules, des chiffres et des tirets',
  'issue.use_lowercase_letters_digits':
    'utilisez des minuscules, des chiffres, - et _',
  'issue.use_lowercase_letters_digits_dashes':
    'utilisez des minuscules, des chiffres et des tirets (max. 60)',
  'issue.use_lowercase_letters_digits_single':
    'utilisez des minuscules, des chiffres et des tirets simples',
  'issue.use_one': 'possibles : {supported}',
  'issue.use_one_2': 'possibles : {CONTENTLOCALES}',
  'issue.use_one_3': 'possibles : {value}',
  'issue.valid_e_mail_address': 'n’est pas une adresse e-mail valide',
  'issue.valid_json_schema': 'n’est pas un schéma JSON valide : {message}',
  'issue.valid_phone_number': 'n’est pas un numéro de téléphone valide',
  'issue.webshop_needs_inventory':
    'la boutique réserve du stock ; désactivez d’abord la boutique',
  'issue.webshop_needs_products':
    'la boutique vend des produits ; désactivez d’abord la boutique',
  'issue.whole_number_min_0': 'must be a whole number ≥ 0',
  'issue.would_create_cycle': 'créerait un cycle',
  'issue.xls_unsupported':
    'Old Excel files (.xls) are not supported. Save the file as .xlsx or CSV.',
  'mail.invalid_plugin_key': "'{pluginKey}' is not a plugin key.",
  'mail.invalid_request': 'Invalid e-mail.',
  'mail.invalid_smtp_settings': 'Invalid e-mail settings.',
  'mail.password_unreadable':
    'The stored SMTP password cannot be read; enter it again.',
  'mail.secrets_key_missing':
    'Set MAIL_SECRETS_KEY on the identity service to store SMTP passwords.',
  'mail.send_plugins_services_only':
    'Only plugins and services send e-mail through this API.',
  'mail.service_not_mail_client':
    "Service '{service}' may not send e-mail (MAIL_CLIENTS).",
  'media.deleted_assets_changed':
    'Les médias supprimés ne peuvent pas être modifiés.',
  'media.file_empty': 'Le fichier est vide.',
  'media.file_part_required': 'Une partie « file » est requise.',
  'media.file_type_allowed_allowed_types':
    'Ce type de fichier n’est pas autorisé. Types autorisés : {allowed}.',
  'media.file_used':
    'Ce fichier est utilisé dans {count} entrées. Si vous le supprimez quand même, il ne s’y chargera plus et ces entrées auront besoin d’un nouveau fichier avant leur prochaine publication.',
  'media.file_used_once':
    'Ce fichier est utilisé dans une entrée. Si vous le supprimez quand même, il ne s’y chargera plus et l’entrée aura besoin d’un nouveau fichier avant sa prochaine publication.',
  'media.files_may_at_most_bytes':
    'Les fichiers ne peuvent pas dépasser {maxBytes} octets.',
  'media.files_may_at_most_bytes_2':
    'Les fichiers ne peuvent pas dépasser {MEDIAMAXBYTES} octets.',
  'media.malformed_upload': 'Téléversement mal formé : {message}',
  'media.owner_scope_invalid': 'A valid owner scope is required.',
  'media.text_file_invalid': 'The text file is not valid UTF-8 text.',
  'media.use_multipart_form_data_file':
    'Utilisez multipart/form-data avec une partie « file ».',
  'media.you_delete_media_you_uploaded':
    'Vous ne pouvez supprimer que les médias que vous avez téléversés.',
  'mobileapp.app_key_required':
    'This API is for approved apps (app key required).',
  'mobileapp.bad_signature': 'The request signature is not valid.',
  'mobileapp.feature_not_granted':
    "This website has not granted the app '{feature}'.",
  'mobileapp.instance_key_mismatch':
    'This app installation is registered with another key.',
  'mobileapp.invalid_decision': 'Invalid decision.',
  'mobileapp.invalid_invite': 'Invalid invite.',
  'mobileapp.invalid_registration': 'Invalid registration request.',
  'mobileapp.invalid_settings': 'Invalid settings.',
  'mobileapp.invite_required':
    'This website accepts app connections only with an invite code.',
  'mobileapp.not_approved': 'The registration is not approved.',
  'mobileapp.not_pending': 'Only a pending request can be refused.',
  'mobileapp.revoke_first': 'Revoke the connection before deleting it.',
  'mobileapp.too_many_requests':
    'Too many registration requests. Please try again later.',
  'plugin.capabilities_requested_manifest_granted':
    'Seules les capacités demandées dans le manifeste peuvent être accordées.',
  'plugin.complete_plugin_configuration_before_enabling':
    'Complétez la configuration de l’extension avant de l’activer.',
  'plugin.disable_dependent_plugins_first':
    'Désactivez d’abord les extensions dépendantes : {value}.',
  'plugin.disable_plugin_before_uninstalling':
    'Désactivez l’extension avant de la désinstaller.',
  'plugin.enable_dependencies_first':
    'Activez d’abord les dépendances : {value}.',
  'plugin.gx_cms_instance_installs_signed':
    'Cette instance GX-CMS n’installe que des paquets d’extension signés.',
  'plugin.incompatible': 'L’extension n’est pas compatible : {problems}',
  'plugin.install_plugin_before_changing_features':
    'Installez l’extension avant de modifier ses fonctionnalités.',
  'plugin.install_plugin_before_granting_capabilities':
    'Installez l’extension avant d’accorder des capacités.',
  'plugin.invalid_collection_record_key':
    'Clé de collection ou d’enregistrement invalide.',
  'plugin.invalid_plugin_configuration': 'Configuration d’extension invalide.',
  'plugin.invalid_plugin_manifest': 'Manifeste d’extension invalide.',
  'plugin.migration_failed': 'La migration « {migId} » a échoué : {message}',
  'plugin.migrations_have_completed': 'Migrations non terminées : {value}.',
  'plugin.needs_service_which_installation_does':
    '« {pluginKey} » nécessite le service « {serviceName} », que cette installation ne connecte pas (SERVICE_PLUGINS).',
  'plugin.no_newer_version_available':
    'Aucune version plus récente n’est disponible.',
  'plugin.package_signature_invalid': 'La signature du paquet est invalide.',
  'plugin.package_signature_invalid_refusing_install':
    'La signature du paquet est invalide ; installation refusée.',
  'plugin.plugin_already_installed':
    'L’extension « {key} » est déjà installée.',
  'plugin.plugin_does_hold_storage_plugin':
    'L’extension ne dispose pas de la capacité storage.plugin.',
  'plugin.plugin_enabled': 'L’extension n’est pas activée.',
  'plugin.plugin_enabled_from_status':
    'L’extension « {key} » ne peut pas être activée depuis le statut {pluginStatus}.',
  'plugin.plugin_installed': 'L’extension n’est pas installée.',
  'plugin.plugin_package_no_longer_present':
    'Le paquet de l’extension n’est plus présent dans le registre.',
  'plugin.records_may_at_most_bytes':
    'Les enregistrements ne peuvent pas dépasser {PLUGINDATAMAXBYTES} octets.',
  'plugin.service_bound_plugin_service_plugins':
    'Le service « {serviceName} » n’est pas connecté à cette extension (SERVICE_PLUGINS).',
  'plugin.service_setup_failed':
    'La configuration du service a échoué : {reason}',
  'plugin.turned_yet': '« {flag} » ne peut pas encore être activé.',
  'plugin.uninstall_dependent_plugins_first':
    'Désinstallez d’abord les extensions dépendantes : {value}.',
  'plugin.uninstall_plugin_before_deleting':
    'Désinstallez l’extension avant de la supprimer.',
  'plugin.unknown_capabilities_provided_dependency':
    'Capacités inconnues (non fournies par une dépendance) : {undeclared}.',
  'plugin.use_retry_migrations_uninstall_first':
    'Relancez les migrations ou désinstallez d’abord.',
  'runtime.migration_already_running':
    'Une migration est déjà en cours pour {pluginKey}.',
  'runtime.migration_failed': 'La migration de l’extension a échoué : {reason}',
  'validation.arrayMaxSize': '{property} contient trop d’éléments',
  'validation.arrayMinSize': '{property} contient trop peu d’éléments',
  'validation.isArray': '{property} doit être une liste',
  'validation.isBoolean': '{property} doit être vrai ou faux',
  'validation.isDateString': '{property} doit être une date ISO',
  'validation.isEmail': '{property} doit être une adresse e-mail',
  'validation.isEnum': '{property} a une valeur non autorisée',
  'validation.isHexColor': '{property} doit être une couleur hexadécimale',
  'validation.isIP': '{property} doit être une adresse IP',
  'validation.isISO8601': '{property} doit être une date ISO',
  'validation.isIn': '{property} a une valeur non autorisée',
  'validation.isInt': '{property} doit être un nombre entier',
  'validation.isLocale': '{property} doit être un code de langue',
  'validation.isNotEmpty': '{property} ne doit pas être vide',
  'validation.isNumber': '{property} doit être un nombre',
  'validation.isObject': '{property} doit être un objet',
  'validation.isPhoneNumber': '{property} doit être un numéro de téléphone',
  'validation.isPositive': '{property} doit être positif',
  'validation.isString': '{property} doit être un texte',
  'validation.isUUID': '{property} doit être un UUID',
  'validation.isUrl': '{property} doit être une URL',
  'validation.length': '{property} n’a pas la bonne longueur',
  'validation.matches': '{property} a un format invalide',
  'validation.max': '{property} est trop grand',
  'validation.maxLength': '{property} est trop long',
  'validation.min': '{property} est trop petit',
  'validation.minLength': '{property} est trop court',
  'validation.nestedValidation': '{property} est invalide',
  'validation.whitelistValidation':
    'La propriété {property} n’est pas autorisée',
  'webshop.active_crm_products_listed':
    'Seuls les produits CRM actifs peuvent être mis en vente.',
  'webshop.amount_too_large': 'Montant trop élevé.',
  'webshop.available': 'Seulement {available} de {viewName} disponible(s).',
  'webshop.available_sale_right_now':
    '{viewName} n’est pas disponible à la vente pour le moment.',
  'webshop.cart_empty': 'Le panier est vide.',
  'webshop.cart_token_missing': 'Le jeton du panier est manquant.',
  'webshop.cart_was_already_checked_out': 'Ce panier a déjà été commandé.',
  'webshop.choose_payment_method': 'Choisissez un moyen de paiement.',
  'webshop.choose_shipping_method': 'Choisissez un mode de livraison.',
  'webshop.configured': '{providerLabel} n’est pas configuré.',
  'webshop.import_columns_missing': 'The file needs sku and name columns.',
  'webshop.import_file_invalid': 'The import file cannot be read.',
  'webshop.import_file_missing': 'A "file" part is required.',
  'webshop.import_malformed': 'Malformed upload: {message}',
  'webshop.import_multipart':
    'Upload the file as multipart/form-data with a "file" part.',
  'webshop.import_too_large': 'The import file may be at most {max} bytes.',
  'webshop.invalid_amount': 'Montant invalide.',
  'webshop.invalid_category': 'Catégorie invalide.',
  'webshop.invalid_code': 'Code invalide.',
  'webshop.invalid_price': 'Prix invalide.',
  'webshop.invalid_quantity': 'Quantité invalide.',
  'webshop.invalid_slug': 'Slug invalide.',
  'webshop.invalid_translations': 'Traductions invalides.',
  'webshop.invalid_webhook_signature': 'Signature de webhook invalide.',
  'webshop.order_action_not_possible':
    'C’est impossible pour une commande au statut « {status} ».',
  'webshop.order_already_belongs_another_account':
    'Cette commande appartient déjà à un autre compte.',
  'webshop.order_has_no_captured_payment':
    'Cette commande n’a aucun paiement encaissé.',
  'webshop.payment_window_order_has_expired':
    'Le délai de paiement de cette commande a expiré.',
  'webshop.please_accept_terms': 'Veuillez accepter les conditions générales.',
  'webshop.product_needs_current_price_price':
    'Le produit nécessite un prix actuel en {currency} dans la liste de prix « {priceList} ».',
  'webshop.refund_exceeds_refundable_amount':
    'Le remboursement dépasse le montant remboursable.',
  'webshop.refunds_supported':
    '{adapterLabel} ne prend pas en charge les remboursements.',
  'webshop.reserved_category': 'Catégorie réservée.',
  'webshop.sales_unavailable':
    'Les prix, le stock et la commande sont momentanément indisponibles. Veuillez réessayer plus tard.',
  'webshop.slug_already_used': 'Le slug « {inputSlug} » est déjà utilisé.',
  'webshop.some_items_changed_please_review':
    'Certains articles ont changé. Veuillez vérifier votre panier.',
  'webshop.some_items_just_sold_out':
    'Certains articles viennent d’être épuisés. Veuillez vérifier votre panier.',
  'webshop.supports_full_refunds':
    '{adapterLabel} ne prend en charge que les remboursements complets.',
  'webshop.test_provider_disabled_production':
    'Le prestataire de test est désactivé en production.',
  'webshop.unexpected_plugin': 'Extension inattendue.',
  'webshop.unknown_tax_category': 'Catégorie de taxe inconnue.',
  // English until translated.
  'crm.attachment_multipart':
    'Envoyez le fichier en multipart/form-data avec une partie « file ».',
  'crm.attachment_too_large': 'Les fichiers ne doivent pas dépasser {max} Mo.',
  'crm.ticket_attachments_invalid': 'Les pièces jointes ne sont pas valides.',
  'crm.ticket_attachments_unknown':
    'Une pièce jointe est introuvable. Envoyez-la à nouveau.',
  'issue.max_files': 'doit contenir au plus {max} fichiers',
}
